var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 83,
    viewBox: "0 0 115 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_26004_15368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.05 80.4C113.59 81.0462 112.983 81.5737 112.279 81.9388C111.574 82.304 110.793 82.4963 110 82.5H5.0002C4.20694 82.4963 3.42595 82.304 2.72173 81.9388C2.01751 81.5737 1.41028 81.0462 0.950195 80.4C20.7002 36.475 16.6002 45.6 22.5002 32.5H92.5002C98.8502 46.625 94.1502 36.2 114.05 80.4Z",
    fill: "#A8C5E3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5003 0V32.5C16.1503 46.625 20.8503 36.2 0.95026 80.4C0.323243 79.5641 -0.0106631 78.5448 0.000259701 77.5V42.5L22.5003 0Z",
    fill: "#D9E7F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 42.5V77.5C115.011 78.5448 114.677 79.5641 114.05 80.4C94.3002 36.475 98.4002 45.6 92.5002 32.5V0L115 42.5Z",
    fill: "#D9E7F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115 43.0002V78.0002C115 79.3262 114.473 80.598 113.536 81.5357C112.598 82.4734 111.326 83.0002 110 83.0002H5C3.67392 83.0002 2.40215 82.4734 1.46447 81.5357C0.526784 80.598 0 79.3262 0 78.0002V43.0002H42.725C43.3279 42.9933 43.913 43.2047 44.3724 43.5952C44.8318 43.9857 45.1346 44.529 45.225 45.1252C45.6105 47.387 46.6111 49.4992 48.1172 51.2302C49.6233 52.9612 51.5768 54.2443 53.7637 54.9388C55.9505 55.6333 58.2864 55.7125 60.5153 55.1677C62.7442 54.6229 64.7801 53.4752 66.4 51.8502C68.2176 50.0157 69.4303 47.669 69.875 45.1252C69.9654 44.529 70.2682 43.9857 70.7276 43.5952C71.187 43.2047 71.7721 42.9933 72.375 43.0002H115Z",
    fill: "#EFF5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5002 0H92.5003V32.5H22.5002V0Z",
    fill: "#C0D6EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 75H13.5C12.837 75 12.2011 74.7366 11.7322 74.2678C11.2634 73.7989 11 73.163 11 72.5C11 71.837 11.2634 71.2011 11.7322 70.7322C12.2011 70.2634 12.837 70 13.5 70H18.5C19.163 70 19.7989 70.2634 20.2678 70.7322C20.7366 71.2011 21 71.837 21 72.5C21 73.163 20.7366 73.7989 20.2678 74.2678C19.7989 74.7366 19.163 75 18.5 75Z",
    fill: "#96B9DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 65H13.5C12.837 65 12.2011 64.7366 11.7322 64.2678C11.2634 63.7989 11 63.163 11 62.5C11 61.837 11.2634 61.2011 11.7322 60.7322C12.2011 60.2634 12.837 60 13.5 60H23.5C24.163 60 24.7989 60.2634 25.2678 60.7322C25.7366 61.2011 26 61.837 26 62.5C26 63.163 25.7366 63.7989 25.2678 64.2678C24.7989 64.7366 24.163 65 23.5 65Z",
    fill: "#96B9DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_26004_15368",
    x: 0.950195,
    y: 32.5,
    width: 113.1,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619653 0 0 0 0 0.746598 0 0 0 0 0.880797 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26004_15368"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/EmptyBox.1b13b62f0cf0a804d8a40211c3112097.svg";
export { ForwardRef as ReactComponent };